import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { UserRolesConditionEnum } from '@ui-core/enums/user-roles.enum'
import { UserService } from '@ui-core/services/user.service'
import { filter, first, map, timeout, catchError } from 'rxjs'
import { of } from 'rxjs'

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const userService = inject(UserService)
    const router = inject(Router)

    return userService.isInitialised$.pipe(
        filter((isInitialised: boolean) => isInitialised),
        first(),
        timeout(15000), // 15 second timeout to allow for MSAL + user fetch
        map(() => {
            const authenticated = userService.get()()?.isLogged

            let routePermissions = route.data['permission'] || { roles: [], condition: 'all' }

            if (!authenticated) {
                return false
            }

            if (route.children.length > 0) {
                routePermissions = route.children[0].data['permission'] || { roles: [], condition: 'all' }
            }

            if (routePermissions.roles.length === 0) {
                return true
            }

            if (routePermissions.condition === UserRolesConditionEnum.Any) {
                if (userService.hasAnyRole(routePermissions.roles)) {
                    return true
                }
            }

            if (routePermissions.condition === UserRolesConditionEnum.All) {
                if (userService.hasRoles(routePermissions.roles)) {
                    return true
                }
            }

            router.navigate([RoutesEnum.FORBIDDEN])
            return false
        }),
        catchError(() => {
            return of(false)
        })
    )
}
